declare let env: any;

export const environment = {
    production: true,
    apiUrl: env?.apiUrl || 'https://api.dev.deckplan.io',
    apiVersion: 'v1',
    stripePublishableKey: 'pk_test_51Hp432GJ3whs2khfKvkS6M196n34huCMThbDK3jUJPt1utxWr94dEWmkjQNcmtgU8PvTxbpmCOzvaLQG63FYqC2700e07Ye5Ex',
    stripePriceId: 'price_1HplF4GJ3whs2khflpOnFjDy'
};
